import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const PrivateRoute = ({ children, publicRoute = false }) => {
  const { loggedUser, loading } = useSelector((state) => state.auth);

  if (loading) return null; // or a spinner

  if (publicRoute) return children;

  return !loggedUser ? <Navigate to="/authentication/sign-in" /> : children;
};

export default PrivateRoute;
